import React, { FC } from "react"

import { Flex } from "@mantine/core"
import SignInCard from "../features/auth/components/signin-card/SignInCard"

const SignIn: FC = () => (
    <Flex
        align="center"
        justify="center"
        p="md"
        sx={theme => ({
            height: "100svh",
            backgroundImage: theme.fn.gradient({
                from: theme.colors.green[8],
                to: theme.colors.blue[5],
                deg: 45,
            }),
        })}
    >
        <SignInCard />
    </Flex>
)

export default SignIn
